import { useAppSelector } from 'store/index';

export const useUserList = () => {
    return useAppSelector(({ userList }) => {
        return userList.list;
    });
};
